<template>
  <div>
    <div class="title">
      <span v-if="type === 'notice'">通知公告</span>
    </div>
    <div class="table">
      <div class="item" v-for="item in noticeList" :key="item.id" @click="routerTo(`/detail`, item)">
        <div><i class="el-icon-d-arrow-right"></i> {{ item.title }}</div>
        <div>{{ formatTimeStamp(item.createdTime*1000) }}</div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @current-change="currentChange"
        :total="total"
        :current-page="currPage"
        :page-size="pageSize"
        layout="prev, pager, next"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {getHomeBannerPage, getNoticePage, getTeamLifePage, getPublicationPage} from '@/api/api'

export default {
  data () {
    return {
      type: '',
      total: 1000,
      currPage: 1,
      pageSize: 20,
      noticeList: []
    }
  },
  created () {
    const type = this.$route.query.type
    console.log(type)
    this.type = type
    this.getNoticePage()
  },
  methods: {
    // 页码切换时触发
    currentChange (e) {
      console.log(e)
      this.currPage = e
      this.getNoticePage()
    },
    // 跳转通用富文本页面
    routerTo (path, row) {
      sessionStorage.detail = JSON.stringify(row)
      this.$router.push({
        path
      })
    },
    getNoticePage () {
      let data = {
        pageSize: this.pageSize,
        currPage: this.currPage
      }
      getNoticePage(data).then(res => {
        if (res.code === 200) {
          this.noticeList = res.data.list
          this.total = res.data.totalCount
        }
      })
    },
    formatTimeStamp (timeStamp) {
      let date = new Date(timeStamp)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  }
}
</script>

  <style scoped>
.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
.serch {
  margin-top: 20px;
}
</style>
  <style scoped>
.table {
  margin-top: 20px;
  border: 3px solid #2f4f4f;
  padding: 5px 20px;
  box-sizing: border-box;
}
.item {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}
.item + .item {
  border-top: 1px solid #2f4f4f8c;
}
.item:hover {
  cursor: pointer;
  color: #d4af37;
}
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/list.vue